'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.joinDate = exports.splitDate = undefined;

var _index = require('../type/index');

var _index2 = require('../number/index');

/**
 * @fileoverview 时间相关
 * @author kirkzheng
 */
var toInt = function toInt(value) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    return parseInt(value, 10) || defaultValue;
};

var fillZero = function fillZero() {
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var value = Number(val) || 0;
    var result = '';

    if (value < 10) {
        result = '0' + value;
    } else {
        result = value + '';
    }

    return result;
};

/**
 * 拆分日期
 * @param {String} date 日期，比如'2018-12-12 12:00:00'
 * @param {String} dateFormat 日期格式，比如'xxxx-xx-xx xx:xx:xx'
 * @returns {Object}
 */
var splitDate = exports.splitDate = function splitDate() {
    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'xxxx-xx-xx xx:xx:xx';

    var format = dateFormat.toLowerCase();
    var reg = new RegExp(format.replace(/x+/gi, '(\\d+)'), 'gi');
    var result = {},
        temp = '',
        tempStr = '';

    if (date && format) {
        reg.exec(date);

        if (RegExp.$1) {
            temp = RegExp.$1 + '';
            temp = temp.length > 4 ? temp.slice(0, 4) : temp;
            result.year = toInt(RegExp.$1);
        }

        if (RegExp.$2) {
            temp = toInt((RegExp.$2 + '').slice(0, 3), 1);
            temp = (0, _index2.adjustValue)(temp, {
                min: 1,
                max: 12
            });
            result.month = temp - 1;
        }

        if (RegExp.$3) {
            temp = toInt((RegExp.$3 + '').slice(0, 3), 1);
            temp = (0, _index2.adjustValue)(temp, {
                min: 1,
                max: 31
            });
            result.date = temp;
        }

        if (RegExp.$4) {
            tempStr = (RegExp.$4 + '').slice(0, 3);
            temp = tempStr === '00' ? 0 : toInt(tempStr, 1);
            temp = (0, _index2.adjustValue)(temp, {
                min: 0,
                max: 23
            });

            result.hour = temp;
        }

        if (RegExp.$5) {
            tempStr = (RegExp.$5 + '').slice(0, 3);
            temp = tempStr === '00' ? 0 : toInt(tempStr, 1);
            temp = (0, _index2.adjustValue)(temp, {
                min: 0,
                max: 59
            });
            result.minute = temp;
        }

        if (RegExp.$6) {
            tempStr = (RegExp.$6 + '').slice(0, 3);
            temp = tempStr === '00' ? 0 : toInt(tempStr, 1);
            temp = (0, _index2.adjustValue)(temp, {
                min: 0,
                max: 59
            });
            result.second = temp;
        }
    }

    return result;
};

/**
 * 聚合日期
 * @param  {Object} data   日期数据
 * @param  {String} dateFormat 日期格式，比如'xxxx-xx-xx xx:xx:xx'
 * @return {String}        日期字符串
 */
var joinDate = exports.joinDate = function joinDate(data) {
    var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'xxxx-xx-xx xx:xx:xx';

    var format = dateFormat.toLowerCase();
    var result = '';

    if (!(0, _index.isUndefined)(data.year)) {
        result = format.replace(/x+/i, data.year);
        result = result.replace(/x+/i, fillZero(toInt(data.month) + 1));
        result = result.replace(/x+/i, fillZero(data.date));
        result = result.replace(/x+/i, fillZero(data.hour));
        result = result.replace(/x+/i, fillZero(data.minute));
        result = result.replace(/x+/i, fillZero(data.second));
    }

    return result;
};

exports.default = {
    splitDate: splitDate,
    joinDate: joinDate
};